import { FontLoader } from 'three/addons/loaders/FontLoader.js';
import { TextGeometry } from 'three/addons/geometries/TextGeometry.js';
import * as THREE from 'three';
import {Box3, Texture} from "three";

export function textNetwork(
    scene: THREE.Scene,
    x: number,
    z: number,
    way: number,
	width: number,
	text: string,
    fontSize: number,
	id: string,
    color: number = 0xffffff
): void {
    const loader = new FontLoader();
    const x1: number = x - (fontSize / 2) + 0.5;

	switch (width) {
		case 6:
			if (text.length > 20) {
				text = text.substring(0, 20) + "...";
			}
			break
		case 10:
			if (text.length > 35) {
				text = text.substring(0, 35) + "...";
			}
			break
		case 14:
			if (text.length > 60) {
				text = text.substring(0, 60) + "...";
			}
			break
		case 18:
			if (text.length > 80) {
				text = text.substring(0, 80) + "...";
			}
			break
		default:
			break
	}

    loader.load(
        'assets/three/FONT/Proxima_Nova_Regular.json',

        (font: any): void => {
            const textGeometry = new TextGeometry(text, {
                font: font,
                size: fontSize,
                depth: 0.00001,
                curveSegments: 64,
                bevelEnabled: true,
                bevelThickness: 0.01,
                bevelSize: 0.01,
                bevelSegments: 5,
            });

			// Boxe pour le click sur le texte
			textGeometry.computeBoundingBox();
			const bbox: Box3 = textGeometry.boundingBox!;
			const clickBoxMesh = new THREE.BoxGeometry(bbox.max.x - bbox.min.x + .2, bbox.max.y - bbox.min.y + .5, 0.0001);
			const clickBoxTexture = new THREE.MeshBasicMaterial({ transparent: true, opacity: 0 });
			const clickBox = new THREE.Mesh(clickBoxMesh, clickBoxTexture);

			// Ligne pour souligner
			const underLineGeo = new THREE.BoxGeometry(bbox.max.x - bbox.min.x, 0.03, 0.0001);
			const underLineMaterial = new THREE.MeshBasicMaterial({ color: color });
			const underLine = new THREE.Mesh(underLineGeo, underLineMaterial);
			underLine.name = `underline-${id}`;

			// Logo
			const logoShape = new THREE.PlaneGeometry(.45, .45);
			const texture: Texture = new THREE.TextureLoader().load('assets/three/TEXTURE/ICON_NETWORK.png' );
			const logoMaterial = new THREE.MeshBasicMaterial( { map:texture, transparent:true, color: color } );
			const logo = new THREE.Mesh(logoShape, logoMaterial);

			// Texte
            const textMaterial = new THREE.MeshBasicMaterial({ color: color });
            const textMesh = new THREE.Mesh(textGeometry, textMaterial);

			clickBox.layers.set(1);
			clickBox.userData.id = id;
			clickBox.userData.modelType = "Network";
			clickBox.userData.underlineName = `underline-${id}`;

			clickBox.userData.underLineRef = underLine;

			// Underline
			underLine.visible = false;

            if (way === 90) {
				clickBox.rotation.set(-Math.PI / 2, 0, Math.PI / 2);
				textMesh.rotation.set(-Math.PI / 2, 0, Math.PI / 2);
            } else {
				underLine.rotation.set(-Math.PI / 2, 0, 0);
				logo.rotation.set(-Math.PI / 2, 0, 0);
				clickBox.rotation.set(-Math.PI / 2, 0, 0);
				textMesh.rotation.set(-Math.PI / 2, 0, 0);
            }
			underLine.position.set(x1 + bbox.max.x/2, 0.001, z + .05);
			logo.position.set(x1 - .4, 0.001, z- bbox.max.y/2);
			clickBox.position.set(x1 + bbox.max.x/2, 0.001, z - bbox.max.y/2);
            textMesh.position.set(x1, 0.001, z);

            scene.add(textMesh, logo, underLine, clickBox);
        },

        (xhr: ProgressEvent): void => {
            if (xhr.total > 0) {
                // console.log((xhr.loaded / xhr.total) * 100 + '% font loaded');
            }
        },

        (err: unknown): void => {
            console.error('An error occurred:', err);
        }
    );
}
